<div class="modal-lg">
  <div class="modal-header">
    <h5 *ngIf="!modal.isError" class="modal-title text-warning d-flex align-items-center">
      <span class="icon-warning mr-2 ft-sz-24"></span>
      {{ 'BaseModal.Warning' | translate}}
    </h5>
    <h5 *ngIf="modal.isError" class="modal-title text-danger d-flex align-items-center">
      <span class="icon-error mr-2 ft-sz-24"></span>
      {{'BaseModal.Warning' | translate}}
    </h5>
    <button type="button" class="close pull-right" aria-label="Fechar" (click)="decline()">
      <span aria-hidden="true" class="icon-close"></span>
    </button>
  </div>
  <div class="modal-body" style="white-space: pre-wrap;">
    <!--<div class="row">
      <div class="col-12">
        <h5><b>{{  'WorkflowCreatePM.PreStage.SubmitPreStage.SubmitMessageOne' | translate}}</b></h5>
      </div>
    </div>
    <br />-->
    <div class="row">
      <div class="col-12">
        <p>{{  'WorkflowCreatePM.PreStage.SubmitPreStage.SubmitMessageFour' | translate}}</p>
      </div>
    </div>
    <!--<div class="row">
      <div class="col-12">
        <h5><b>{{  'WorkflowCreatePM.PreStage.SubmitPreStage.SubmitMessageThree' | translate}}</b></h5>
      </div>
    </div>-->
  </div>
  <div class="modal-footer">
    <button *ngIf="!modal.cancelButton?.hideButton" type="button" class="btn" [class]="cancelButtonClass"
            aria-label="Cancelar" (click)="decline()">
      <span [class]="cancelIcon"></span>
      <span>{{'WorkflowCreatePM.PreStage.Alerts.Anular' | translate}}</span>
    </button>
    <button *ngIf="!modal.isError" type="button" class="btn btn-primary"
       
            aria-label="Continuar" (click)="confirm()">
      <span class="icon-check"></span>
      <span>{{'WorkflowCreatePM.PreStage.Alerts.Confirmar' | translate}}</span>
    </button>
  </div>
</div>
